<template>
  <div class="home">
    This is visitors index view
    <router-view></router-view>
  </div>
</template>

<script>

export default {
    name: 'requests'
};
</script>
